import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Button } from 'react-toolbox'
import CSSModules from 'react-css-modules'

import styles from './styles.scss'

class AddConfig extends Component {
  onAddConfig() {
    if (this.props.onEditPart && this.props.isEdit!==''){
      return () => {
        this.props.onEditPart(this.props.isEdit, this.props.configSource)
        this.props.onTogglePopup()
        this.props.onUpdateConfig([])
        this.props.onUpdateConfigSource([])
        this.props.onRefreshFilter()
      }
    }
    else {
      return () => {
      this.props.onAddPart(this.props.configSource)
      this.props.onTogglePopup()
      this.props.onUpdateConfig([])
      this.props.onUpdateConfigSource([])
      this.props.onRefreshFilter()
      }
    }
  }

  render() {
    const {
      configSelection,
      isEdit,
      setEditPart
    } = this.props

    return(
      <Button
        icon='add'
        label='ADD CONFIGURATION(S)'
        flat
        primary
        disabled={ configSelection.length === 0 }
        onClick={this.onAddConfig()}
        theme={styles}
      />
    )
  }
}

AddConfig.propTypes = {
  configSelection: PropTypes.array.isRequired,
  configSource: PropTypes.array.isRequired,

  curConfig: PropTypes.object.isRequired,

  onAddPart: PropTypes.func.isRequired,
  onUpdateConfig: PropTypes.func.isRequired,
  onUpdateConfigSource: PropTypes.func.isRequired,
}

export default CSSModules(AddConfig, styles)
